import * as angular from "angular";

import {newsletterDataTableConfig} from './newsletter-data-table/newsletter-data-table.component';
import {newsletterConfig} from './newsletters.component';
import NewslettersStateService from './newsletters-state.service';
import OutputConfig from '../../config/config';

export default angular
    .module('mw.newsletters', [
        'MW.OutputNewsletter.OutputNewsletterService',
        'MW.OutputNewsletter.OutputNewsletterDistributionService',
        'MW.OutputMgr.OutputMgrService',
        'MW.Framework.TextFilters',
        'MW.Framework.CoreUserService',
        'MW.Framework.CoreCompanyService',
        'MW.Framework.AnalyticsService',
        'MW.Framework.AppBarTitleService',
        'MW.Framework.EntitlementService',
        'MW.ToggleFeature'
        ]
    )
    .component(newsletterDataTableConfig.selector, newsletterDataTableConfig)
    .component(newsletterConfig.selector, newsletterConfig)
    .service('NewslettersStateService', NewslettersStateService)
    .service('OutputConfig', OutputConfig)
    .config(['ToggleFeatureProvider', 'ENV', function(ToggleFeatureProvider, ENV) {
        ToggleFeatureProvider.setConfig({
            env: ENV
        });
    }])
    .name;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletters/newsletters.module.ts
 **/